/**
 * Analytics Tracking Module
 * Provides centralized analytics event tracking functionality using Google Tag Manager's dataLayer
 */

window.Analytics = (function () {
  'use strict';

  /**
   * Track analytics events by pushing to dataLayer
   * @param {string} eventName - The name of the event to track
   * @param {Object} eventParams - Additional parameters to include with the event
   */
  function trackAnalyticsEvent(eventName, eventParams = {}) {
    try {
      // Initialize dataLayer if it doesn't exist
      window.dataLayer = window.dataLayer || [];
      
      // Push event to dataLayer
      window.dataLayer.push({
        event: eventName,
        ...eventParams,
      });

      // Optional: Log for debugging in development
      if (window.location.hostname === 'localhost' || window.location.hostname.includes('myshopify.com')) {
        console.log('Analytics Event Tracked:', eventName, eventParams);
      }
    } catch (error) {
      console.warn('Analytics tracking failed:', error);
    }
  }

  /**
   * Track ecommerce-specific events with standardized parameters
   * @param {string} eventName - The name of the ecommerce event
   * @param {Object} params - Event parameters
   * @param {string} params.event_category - Event category (defaults to 'ecommerce')
   * @param {string} params.event_label - Event label
   * @param {string|number} params.event_value - Event value
   * @param {Object} params.custom_parameters - Custom parameters
   */
  function trackEcommerceEvent(eventName, params = {}) {
    const defaultParams = {
      event_category: 'ecommerce',
      ...params,
    };

    trackAnalyticsEvent(eventName, defaultParams);
  }

  /**
   * Track payment-related analytics events
   * @param {string} orderId - The order ID
   * @param {string} normalizedStatus - The normalized payment status
   */
  function trackPaymentAnalytics(orderId, normalizedStatus) {
    trackEcommerceEvent('payment_initiated', {
      event_label: `order_${orderId}`,
      payement_status: normalizedStatus,
    });
  }

  /**
   * Track invoice download events
   * @param {boolean} isMultiple - Whether multiple invoices are being downloaded
   * @param {number} invoiceCount - Number of invoices being downloaded
   */
  function trackInvoiceDownload(isMultiple, invoiceCount = 1) {
    const eventName = isMultiple ? 'invoices_download_multi' : 'invoices_download_single';
    trackEcommerceEvent(eventName, {
      event_value: invoiceCount,
    });
  }

  // Public API
  return {
    trackAnalyticsEvent,
    trackEcommerceEvent,
    trackPaymentAnalytics,
    trackInvoiceDownload,
  };
})();
